import RetreatCourseRepository from '@/domain/repositories/RetreatCourseRepository';
import RetreatCourseDataStore from '../datastores/RetreatCourseDataStore';
import RetreatCourseDataStoreFactory from '../factories/RetreatCourseDataStoreFactory';

export default class RetreatCourseDataRepository
  implements RetreatCourseRepository
{
  activateWithdrawalCourses(requestId: number) {
    const retreatCourseDataStore: RetreatCourseDataStore =
      RetreatCourseDataStoreFactory.create();
    return retreatCourseDataStore.activateWithdrawalCourses(requestId);
  }

  registerWithdrawalCourses(procedureId: number, courseWithdrawals: any) {
    const retreatCourseDataStore: RetreatCourseDataStore =
      RetreatCourseDataStoreFactory.create();
    return retreatCourseDataStore.registerWithdrawalCourses(
      procedureId,
      courseWithdrawals
    );
  }
}
